import React from 'react';
import { trackEvent } from '../hooks/usePageTracking';

export interface Issue {
  id: string | number;
  title: string;
  short_description: string;
  long_essay: string;
}

interface Props {
  issue: Issue;
}

const IssueCard: React.FC<Props> = ({ issue }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    trackEvent(next ? 'card_open' : 'card_close', issue.title);
  };

  return (
    <article className="issue-card">
      <h4
        className="issue-title"
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <span>{issue.title}</span>
        <span
          className={`issue-toggle-icon${isOpen ? ' issue-toggle-icon--open' : ''}`}
          aria-hidden="true"
        >
          ›
        </span>
      </h4>
      <p className="issue-description">{issue.short_description}</p>
      <div className={`issue-essay-wrapper${isOpen ? ' issue-essay-wrapper--open' : ''}`}>
        <div
          className="issue-essay"
          dangerouslySetInnerHTML={{ __html: issue.long_essay }}
        />
        <button
          className="back-to-top-link"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          ↑ Zurück nach oben
        </button>
      </div>
    </article>
  );
};

export default IssueCard;
